export type CommandType = {
    description: string;
    action: string;
    activateOnEnter?: boolean;
    function?: (values?: string[]) => void;
};

export const useCommands = () => {
    const commands: CommandType[] = [];
    return { commands };
};
